import React, {FC, memo, useState} from 'react'
import {IconButton, Modal, Stack, Typography} from "@mui/material";
import {WebShopIcon} from "@/src/components/WebShopIcon";
import {OtpField} from "@/src/components/Fields/OtpField";
import {Button} from "@/src/components/Button";
import {strings} from "@/src/shared/strings";
import {OtpInfo} from "@/src/components/OrderAuthModal/model";
import { FormProvider, UseFormReturn} from "react-hook-form";
import {TextWithTimer} from "@/src/components/TextWithTimer";

interface OtpModalProps {
    form: UseFormReturn<{ controlCode: string | null | undefined; phoneNumberCode: string; }>
    email: string;
    otpInfo: OtpInfo | null;
    isLoading?: boolean;
    onResend: () => void;
    onAccept: (phoneNumberCode: string) => void;
    onCancel: () => void;
}

const OtpModal: FC<OtpModalProps> = ({ form, email, otpInfo, isLoading, onResend, onAccept, onCancel }) => {
    const [isResendAvailable, setIsResendAvailable] = useState(false);

    return (
        <Modal open={!!otpInfo} onClose={onCancel}>
            <FormProvider {...form}>
                <Stack
                    className={
                        "flex max-w-[524px] flex-col items-center gap-4 rounded-xl bg-white p-6 center-modal max-md:h-full overflow-y-auto max-md:animate-up-modal max-md:items-start max-md:rounded-none max-md:pt-24 max-md:bottom-modal"
                    }
                >
                    <Stack className={"w-full flex-center-row"}>
                        <Typography
                            variant={"h1"}
                            component={"h3"}
                            className={
                                "flex-1 justify-center text-center text-2xl max-md:text-start"
                            }
                        >
                            {"Підтвердження"}
                        </Typography>
                        <IconButton onClick={onCancel} className="max-md:hidden">
                            <WebShopIcon name={"close"} className="fill-blue" />
                        </IconButton>
                    </Stack>
                    <Stack className="flex flex-col">
                        {email && (
                            <Typography
                                component={"p"}
                                className={"text-center max-md:text-start"}
                            >
                                На Вашу електронну адресу{" "}
                                <Typography
                                    component="span"
                                    className="inline font-semibold"
                                >
                                    {email}
                                </Typography>{" "}
                                надійшов код для підтвердження особи.
                            </Typography>
                        )}
                    </Stack>
                    <Stack className="flex flex-col gap-4">
                        <OtpField control={form.control} name={"phoneNumberCode"} />
                        {otpInfo?.errors && otpInfo?.errors?.length > 0 && (
                            <div className="text-xs font-normal text-red">
                                {otpInfo?.errors[0].errorDescription}
                            </div>
                        )}
                        {otpInfo?.controlCode ? <div className="flex items-center gap-1">
                            <Typography className="font-semibold">
                                Контрольний код: {otpInfo?.controlCode}
                            </Typography>
                        </div> : null}
                        <div className={"text-center"}>
                            {isResendAvailable ? (
                                <Typography
                                    variant="body1"
                                    className={"cursor-pointer"}
                                    onClick={() => {
                                        onResend();
                                        setIsResendAvailable(false);
                                    }}
                                >
                                    Надіслати код повторно
                                </Typography>
                            ) : (
                                <TextWithTimer onTimerEnd={() => setIsResendAvailable(true)} />
                            )}
                        </div>
                    </Stack>
                    <Stack className="w-full justify-end gap-3 flex-center-row max-md:mt-auto">
                        <Button
                            onClick={onCancel}
                            variant="outlined"
                            className="w-fit max-md:w-full"
                        >
                            {strings.common.revoke}
                        </Button>
                        <Button
                            onClick={() => onAccept(form.getValues('phoneNumberCode'))}
                            loading={isLoading}
                            disabled={!otpInfo?.controlCode}
                            className="w-fit max-md:w-full"
                        >
                            {"Підтвердити"}
                        </Button>
                    </Stack>
                </Stack>
            </FormProvider>
        </Modal>
    )
}

export default memo(OtpModal)
